import { IS_PROD } from "./config/env.config";

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const CLIENT_REDIRECT_BASE = process.env.REACT_APP_Client_RedirectUrl;
export const API_LOGO_BASE_URL = process.env.REACT_APP_API_LogoBaseUrl;
const API_FILE_URL = process.env.REACT_APP_API_FileUrl;
const APPLICATION_SERVICE_URL = process.env.REACT_APP_APPLICATION_SERVICE_URL;
const DATA_CLEANING_URL = process.env.REACT_APP_DATA_CLEANING_URL;
const APPLICATION_NAME = process.env.REACT_APP_APPLICATION_NAME;
const EMAIL_RATING = process.env.REACT_APP_EMAIL_RATING;
const LORRI_SEARCH = process.env.REACT_APP_LORRI_SEARCH;
const AZURE_SPOT = process.env.REACT_APP_AZURE_SPOT;
const BENCHMARK_UPLOAD_FILE = process.env.REACT_APP_BENCHMARK_UPLOAD_FILE;
const API_BUSINESS_ENQUIRIES = process.env.REACT_APP_API_BusinessEnquiries;
const INTERNAL_APIS_BASE = process.env.REACT_APP_INTERNAL_APIS_BASE;
const PROCUREMENT_BASE_URL_BASE =
  process.env.REACT_APP_Procurement_BaseUrl_Base;
const DC_BASE_URL = process.env.REACT_APP_DC_BaseUrl;
const LORRI_DASHBOARD = process.env.REACT_APP_LORRI_DASHBOARD;

// Consolidated URLs (Privatized redundant paths)
const AUCTION_BASE_URL = `${API_BASE_URL}/`;
const LOGISTICS_PLANNING_URL = `${API_BASE_URL}/api/planning`;
export const PPT_URL = `${DATA_CLEANING_URL}/api/ppt_lorri`;
const PROCUREMENT_BASE_URL = `${PROCUREMENT_BASE_URL_BASE}/lanes`;
const API_ENQUIRY_CHAT = `${INTERNAL_APIS_BASE}/api/truck_enquiry_chat?code=XaESaF5xua0WkDWuSl9OZfVowjmjl6KLcMMJv0sCWPfL1SgM4RBUfA==&environment=${IS_PROD ? "production" : "staging"}`;
const EMAIL_TEMPLATE = `${INTERNAL_APIS_BASE}/api/editble_emails?environment=${IS_PROD ? "production" : "staging"}`;

const BaseUrl = API_BASE_URL;
const SpotBaseUrl = API_BASE_URL;
const UserBaseUrl = API_BASE_URL;
const IndentBaseUrl = API_BASE_URL;
const LogisticsPlanningBaseUrl = LOGISTICS_PLANNING_URL;
const FileUrl = API_FILE_URL;
const lorriApplicationService = APPLICATION_SERVICE_URL;
const dataCleaningUrl = DATA_CLEANING_URL;
// const EnquiryChat = API_ENQUIRY_CHAT;
// const Dashboard_api = LORRI_DASHBOARD;
const LogoUrl = API_LOGO_BASE_URL;
const MixPanelApplicationname = APPLICATION_NAME;
const AuctionBaseUrl = AUCTION_BASE_URL;
const EmailBaseUrl = EMAIL_RATING;
// const EmailTemplate = EMAIL_TEMPLATE;
const LorriSearch = LORRI_SEARCH;
const SPOTAZURE = AZURE_SPOT;

export const DC_URL = DC_BASE_URL;
export const benchmarkUploadContainerName = BENCHMARK_UPLOAD_FILE;

const API_LORRI = `${BaseUrl}/api/apilorri`;
const MFA_LORRI = `${BaseUrl}/api/mfa`;
const API_USER = `${UserBaseUrl}/api/apiuser`;
const API_INDENT = `${IndentBaseUrl}/api/indent`;
const API_SPOT = `${SpotBaseUrl}/api/spot`;
const API_PLANNING = `${LogisticsPlanningBaseUrl}/`;
const API_AGENT = `${BaseUrl}/api/lorri-agent/`;

export const MASTER_URLS = {
  FREIGHT: `${CLIENT_REDIRECT_BASE}/companyprofilenew/masters/freightmaster`,
  LOCATION: `${CLIENT_REDIRECT_BASE}/companyprofilenew/masters/locationmaster`,
  VENDOR: `${CLIENT_REDIRECT_BASE}/companyprofilenew/masters/vendormaster`,
  TRUCK: `${CLIENT_REDIRECT_BASE}/companyprofilenew/masters/truckmaster`,
  MATERIAL: `${CLIENT_REDIRECT_BASE}/companyprofilenew/masters/materialmaster`,
  ROUTE: `${CLIENT_REDIRECT_BASE}/companyprofilenew/masters/routemaster`,
};

export const PROCURE_URLS = {
  BASE: PROCUREMENT_BASE_URL_BASE,
  LOGIN: (uid) => `${PROCUREMENT_BASE_URL_BASE}/login?id=${uid}`,
  AUCTION: `${PROCUREMENT_BASE_URL_BASE}/auction`,
  ANALYZE_NOW: (uid, procId) =>
    `${PROCUREMENT_BASE_URL_BASE}/login?id=${uid}&screen=analyzeNow&procurementId=${procId}`,
  MANAGE: (procId) => `${PROCUREMENT_BASE_URL_BASE}/lanes/${procId}`,
};

export const TRACKING_DETAILS_URL = (indentId, indentIdSub) =>
  `${CLIENT_REDIRECT_BASE}/trackingdetails/${indentId}/${indentIdSub}`;

export const SPOT_URL = `${CLIENT_REDIRECT_BASE}/trucks/enquiries`;
export const CLIENT_REDIRECT_URL = `${CLIENT_REDIRECT_BASE}/companyprofilenew/masters/freightmaster`;

export const Urls = {
  oldIndentUrl: `${SPOTAZURE}`,
  planning: `${API_PLANNING}`,
  getMfaStatus: `${MFA_LORRI}/status`,
  capacity_planning: `${API_PLANNING}/autodispatch`,
  logistics_planning: `${API_PLANNING}/load_optimizer`,
  edit_planning_loads: `${API_PLANNING}/edit_loads`,
  signup_mails: `${API_USER}/user`,
  Transporters: {
    GetAll: `${API_LORRI}/transporter_search`,
    Get: `${API_USER}/transporter_details`,
    Get1: `${API_LORRI}/transporter_info`,
    Recommend: `${API_LORRI}/recommend_transporter`,
    UpdateTransporter: `${API_USER}/transporter`,
    SendgridEmail: `${API_LORRI}/trigger_email`,
    SmtpEmail: `${API_LORRI}/trigger_email`,
    GetUserDetails: `${API_USER}/user_details`,
    GetMyTransporters: `${EmailBaseUrl}/api/my_transporters`,
    Rating: `${EmailBaseUrl}/api/rating`,
    Delete: `${API_LORRI}/transporterlist_edit`,
    GetSimilarTransporter: `${API_LORRI}/similar-transporters`,
    Shortlist: `${API_LORRI}/shortlists `,
    mailservice: `https://smtpemailservice.azurewebsites.net/api/Email_Service?code=/niHyaTO0jFc9sVjBdDgRKkLdWi23SKgE62yl5whBJXXaXWaJZsOfw==`,
  },
  dashboard: `${API_LORRI}/dashboard`,
  inmail: API_BUSINESS_ENQUIRIES,
  RecommendTransporter: `${API_LORRI}/rated-transporters`,
  transportersWiseLanes: `${AuctionBaseUrl}api/ratecard`,
  auctionProcurement: `${AuctionBaseUrl}api/procurements`,
  procurementFilters: `${AuctionBaseUrl}api/filters`,
  Users: {
    GetCurrentUser: `${API_USER}/user_details`,
  },
  PhoneRecovery: `${API_USER}/phone_recovery`,
  preLogin: `${MFA_LORRI}/pre-login`,
  rememberDevice: `${MFA_LORRI}/remember-device`,
  MFA_LORRI: `${MFA_LORRI}/phone_recovery`,
  References: {
    Save: `${API_LORRI}/post_referrals`,
  },
  VAS: {
    Save: `${API_LORRI}/post_value_added_services`,
  },
  User: {
    Get: {
      ServicesAndReferrals: `${API_LORRI}/get_value_added_services_referrals`,
    },
    Post: {
      Referral: `${API_LORRI}/post_value_added_services_referrals`,
    },
  },
  Autocomplete: {
    Get: {
      getlist: `${API_USER}/autocomplete`,
      getTransporterName: `${API_USER}/transporter_dataV2`,
    },
    Post: {
      bulkSuggestion: `${API_USER}/autocomplete`,
    },
  },
  MyAccount: {
    Get: {
      RatedTransporters: `${EmailBaseUrl}/api/rated-transporters`,
      ShortlistedTransporters: `${API_LORRI}/shortlists`,
      ReferalsAndVAS: `${API_LORRI}/get_value_added_services_referrals`,
    },
  },
  template: "https://lndocs.blob.core.windows.net/transpporterlogo/index.html",
  ipinfo: `https://cors-anywhere.herokuapp.com/https://api.ipify.org/?format=json`,
  globe: "https://adhoclorri.azurewebsites.net/api/geocoderapi",
  globeget: "https://adhoclorri.azurewebsites.net/api/coordinates",
  azureSearch:
    "https://networksearch.search.windows.net/indexes/location-index/docs?api-version=2019-05-06&search=*&$top=2000",
  locationapi: `${API_LORRI}/location-analysisv2?code=403uUoAMJkkEU69D8NsM0jCVxKFfvON0ROo4uLEnJQY9YfX4/9ursg==`,
  locationapi2: `${API_LORRI}/location-analysis`,

  blobUrl: "https://blobfileupload.azurewebsites.net/api/blobfile",
  services: {
    GET: `https://genericfeatures.azurewebsites.net/api/get_services`,
    POST: `https://genericfeatures.azurewebsites.net/api/post_services`,
  },
  CompareUrl: `${API_LORRI}/transporter-comparison`,
  logURL: `${API_LORRI}/log`,
  spotAgent: `${API_AGENT}/spot-agent`,
  spot: `${API_SPOT}/lorri_spot_v2`,
  spot_dashboard: `${API_SPOT}/lorri_adhoc_dashboard_v2`,
  spot_data: `${API_SPOT}/spot_data`,
  user_data: `${API_USER}/user`,
  DiscoverNow: `${API_LORRI}/search?search_field=transporters`,
  fileUploadService: ` https://fileuploadservice.azurewebsites.net/api/${FileUrl}`,
  uploadServiceNew: `${API_LORRI}/fileuploadnew`,
  getActiveprocurement: `${API_LORRI}/procurements/`,
  benchmarnow: `${API_LORRI}/benchmarknow`,
  benchmarkUploadReviewLocations: `${API_LORRI}/benchmark_upload/review/locations`,
  benchmarkUploadReviewTrucks: `${API_LORRI}/benchmark_upload/review/trucks`,
  benchmarkUploadConfirmLanes: `${API_LORRI}/benchmark_upload/confirm_lanes`,
  benchmarkUploadSubmit: `${API_LORRI}/benchmark_upload/submit`,
  benchmarkUploadGetResult: `${API_LORRI}/benchmark_upload/result`,
  benchmarkUploadGetLogs: `${API_LORRI}/benchmark_upload/get_excel_logs`,
  spot_filters: `${API_SPOT}/spot_filters`,
  filters: `${API_LORRI}/filters`,
  planning_master_filters: `${LogisticsPlanningBaseUrl}/filters`,
  settings: `${API_LORRI}/settings`,
  ContractNow: `${API_LORRI}/contract-details`,
  logisticsnowFileService:
    "https://logisticsnowfileservice.azurewebsites.net/api/blob-upload",
  logisticsnowFileService_python:
    "https://automatedapitesting.azurewebsites.net/api/fileupload",
  fileService: `${lorriApplicationService}/api/fileupload`,
  PptGeneration: `${dataCleaningUrl}/api/ppt_lorri`,
  streamingData: `${API_LORRI}/streaming-data`,
  getPaymentDetails: `${API_LORRI}/user_policy_data`,
  policyUpdate: `${API_USER}/user_transporter`,
  enquiryChat: `${API_SPOT}/truck_enquiry_chat?code=XaESaF5xua0WkDWuSl9OZfVowjmjl6KLcMMJv0sCWPfL1SgM4RBUfA==`,
  indentTransporters: `${API_INDENT}/indent_lorri?field=transporter_network`,
  indent: `${API_INDENT}/indent_lorri`,
  indentRootUrl: `${API_INDENT}/`,
  indentSimBased: `${API_INDENT}/sim_based`,
  createIndent: `${API_INDENT}/indent_lorri?field=create_indent`,
  createMultipleIndent: `${API_INDENT}/indent_lorri?field=create_multiple_indent`,
  allindents: `${API_INDENT}/indent_lorri?field=id`,
  indentdashboard: `${API_INDENT}/indent_lorri`,
  indent_chat: `${API_INDENT}/indent_chat?code=CpidrqVD4RMunlYuFdRI4ymhQE5qr/za85HbgawlVtXPvBDjvQb06Q==`,
  indentTrackAndTrace: `${API_INDENT}/track_n_trace`,
  auctionlorri: `${AuctionBaseUrl}/api/lorriauction`,
  invoice: `${API_INDENT}/invoice_lorri`,
  companyProfile: `${API_USER}/company_profile`,
  companyMaster: `${API_PLANNING}/company_master`,
  rfq: `${API_LORRI}/rfq`,
  save_transporters: `${API_LORRI}/save_lanelevel_transporters`,
  billing: `${API_LORRI}/user_policy_data`,
  freight_master: `${API_LORRI}/freight_master`,
  showlogo: `${LogoUrl}`,
  mixpanelappname: `${MixPanelApplicationname}`,
  freight_transporter: `${API_LORRI}/contracted_transporters`,
  email_template: `${API_SPOT}/editble_emails`,
  trucks_enquiry_by_email: `${API_LORRI}/Trucks_enquiry_by_email`,
  adhoc_dashboard: `${API_SPOT}/lorri_adhoc_dashboard`,
  search_results: `${LorriSearch}/lorrisearch`,
  search_log: `${LorriSearch}/search_log`,
  gigo: `${API_LORRI}`,
  approval_control: `${API_LORRI}`,
  report_generator: `${API_LORRI}`,
  invoice_lorri: `${API_INDENT}/invoice_lorri`,
  fuel_rate: `${API_LORRI}/`,
  invoice_tpmp: `${API_INDENT}/invoice_tpmp`,
  LorriLogoLogin:
    "https://rnrdeploynew.blob.core.windows.net/staticimages/LoRRI_screen_zero-min.png",
  spot_enquiries: SPOT_URL,
};
